import { FC, useMemo, useState } from 'react';
import s from './Search.module.css';
import h from '../History/History.module.css';
import { ReactComponent as Arrows } from 'images/arrows.svg';

import { useAppSelector } from 'store/hooks';
import { useNavigate, useOutletContext } from 'react-router';
import { SearchInput } from 'components/common/SearchInput';
import { filter, groupingChats } from 'lib/utils/common';
import { selectChats } from 'store/features/chat/selectors';
import { ScrollableContainer } from 'components/common/ScrollableContainer';
import { Modal } from 'components/common/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { ModalNavigationContext } from 'components/pages/ConsultantPage/ConsultantPage';

type SearchProps = {};

export const Search: FC<SearchProps> = () => {
  const { t } = useTranslation();
  // const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { closeRouteModal } = useOutletContext<ModalNavigationContext>();

  const chats = useAppSelector(selectChats);

  const [value, setValue] = useState('');
  const [toggledGroups, setToggledGroups] = useState<Record<string, boolean>>(
    {},
  );

  const changeInputValue: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setValue(e.target.value);
  };

  const isGroupOpen = (key: string) =>
    toggledGroups[key] ??
    (Boolean(value) || key === 'pinned' || key === 'today');

  const handleToggleGroup = (key: string) => {
    setToggledGroups((prev) => ({ ...prev, [key]: !isGroupOpen(key) }));
  };

  const handleGetChat = async (chatId: string) => {
    navigate(`/chat/${chatId}`);
  };

  // const handleDeleteChat = useCallback(async (chatId: string) => {
  //   // console.log('delete');
  //   // if (!chatId) return;
  //   // if (isLoading) return;
  //   // setIsLoading(true);
  //   // try {
  //   //   await dispatch(deleteChat(chatId)).unwrap();
  //   //   navigate(`/consultant`);
  //   //   // setActiveOption(ActiveOption.NewChat);
  //   // } catch (err) {
  //   //   setError(err as string);
  //   // } finally {
  //   //   setIsLoading(false);
  //   // }
  // }, []);

  // const handleRenameChat = useCallback(
  //   async (chatId: string, newName: string) => {
  //     // if (!chatId) return;
  //     // if (isLoading) return;
  //     // setIsLoading(true);
  //     // try {
  //     //   await dispatch(
  //     //     renameChat({ id: chatId, name: newName.trim() }),
  //     //   ).unwrap();
  //     // } catch (err) {
  //     //   setError(err as string);
  //     // } finally {
  //     //   setIsLoading(false);
  //     // }
  //   },
  //   [],
  // );

  const filterList = useMemo(
    () => filter(value, chats, 'name'),
    [value, chats],
  );

  const groups = useMemo(
    () => groupingChats(filterList).filter((group) => group.list.length),
    [filterList],
  );

  return (
    <Modal title={t('navigationPanel.search')} onClose={closeRouteModal}>
      <div className={s.content}>
        <SearchInput
          value={value}
          onChange={changeInputValue}
          placeholder={t('navigationPanel.search')}
          name={t('navigationPanel.search')}
        />

        <ScrollableContainer scrollHeight='35rem'>
          {groups.length ? (
            <div>
              {groups.map((group) => (
                <section key={group.key}>
                  <div
                    className={h['list-title']}
                    onClick={() => handleToggleGroup(group.key)}
                  >
                    {t(group.title)}
                    <div
                      className={h['list-title__icon']}
                      data-open={isGroupOpen(group.key)}
                    >
                      <Arrows className={h.arrows} />
                    </div>
                  </div>
                  {isGroupOpen(group.key) && (
                    <ul>
                      {group.list.map((chat) => (
                        <li
                          key={chat.id}
                          className={s.item}
                          onClick={() => handleGetChat(chat.id)}
                        >
                          <span className={s.item__name}>{chat.name}</span>
                          <span className={s.item__date}>
                            {new Date(chat.date).toLocaleDateString()}
                          </span>
                        </li>
                      ))}
                    </ul>
                  )}
                </section>
              ))}
            </div>
          ) : (
            <span>{t('errors.noResults')}</span>
          )}
        </ScrollableContainer>
      </div>
    </Modal>
  );
};
